import React, {useEffect} from "react";
import s from "./topClients.module.scss";
import {useDispatch, useSelector} from "react-redux";
import useGetSearchParams from "../../../../../hooks/useGetSearchParams";
import CustomSkeleton from "../../../../../components/UiKit/CustomSkeleton/CustomSkeleton";
import {
    topBestClientsColumnsList, topWorstClientsColumnsList,
} from "../../../../../utils/vars/params";
import {useTranslation} from "react-i18next";
import {
    clientAnalyticsSelector, fetchRate, resetRateData,
} from "../../../../../redux/slices/clientAnalyticsSlice";
import {convertDate} from "../../../../../utils/helpers/formatTime";
import {ANDROID} from "../../../../../utils/vars/staticVariables";


const TopClients = () => {

    const {
        androidTop10Customers,
        androidBottom10Customers,
        androidTopCustomersPending
    } = useSelector(clientAnalyticsSelector);

    const dispatch = useDispatch();

    const {
        content: contentValue
    } = useGetSearchParams();

    const {t} = useTranslation();

    useEffect(() => {
        dispatch(fetchRate({os: ANDROID}))
    }, [contentValue, dispatch])


    const today = new Date();
    const thirtyDaysAgo = new Date(today);
    thirtyDaysAgo.setDate(today.getDate() - 30);

    const tables = [
        {
            data: androidTop10Customers,
            columnNames: topBestClientsColumnsList
        },
        {
            data: androidBottom10Customers,
            columnNames: topWorstClientsColumnsList
        },
    ]

    useEffect(() => {
        return () => {
            dispatch(resetRateData(ANDROID))
        }
    }, [dispatch]);

    return (
        <div className={s.usersTableWrapper}>

            <div className={s.pageInnerContent}>

                <div className={s.tableContainer}>

                    {
                        tables.map(({data, columnNames}, index) => {

                            return (
                                <section className={s.body}>
                                    <table>
                                        <thead>
                                        <tr>
                                            <th
                                                className={s.thDatePicker}
                                                colSpan="4"
                                            >
                                                <div className={s.datePickersWrapper}>
                                                    {
                                                        <>
                                                            <div className={s.datePicker}>
                                                                <div className={s.dateContainer}>
                                                                    {t('from')}
                                                                    {' '}
                                                                    {convertDate(thirtyDaysAgo, 'DMY')}
                                                                </div>
                                                            </div>
                                                            <div className={s.datePicker}>
                                                                <div className={s.dateContainer}>
                                                                    {t('to')}
                                                                    {' '}
                                                                    {convertDate(today, 'DMY')}
                                                                </div>
                                                            </div>

                                                        </>
                                                    }
                                                </div>
                                            </th>
                                        </tr>
                                        <tr>
                                            {
                                                columnNames.map(({name}, index) => <th
                                                    key={index}>{t(name)}</th>)
                                            }
                                        </tr>
                                        </thead>

                                        <tbody>

                                        {
                                            androidTopCustomersPending
                                                ? <tr>
                                                    <td colSpan='4'>
                                                        <div className={s.skeletonWrapper}>
                                                            <CustomSkeleton styles={s.skeletonTable}/>
                                                        </div>
                                                    </td>
                                                </tr>
                                                : data.length > 0
                                                    ? data.map(({installs, percent, user}, index) => {
                                                        return (
                                                            <tr key={user}>
                                                                <td>{t('client')}{" "}{index + 1}</td>
                                                                <td>{user}</td>
                                                                <td>{installs}</td>
                                                                <td
                                                                    className={`${percent.includes('+') ? s.green : s.red}`}
                                                                >
                                                                    {percent}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                    : <tr>
                                                        <td
                                                            colSpan="4"
                                                        >
                                                            <div className={s.noRecords}>{t("records_not_found")}</div>
                                                        </td>
                                                    </tr>
                                        }
                                        </tbody>
                                    </table>
                                </section>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    );
};

export default TopClients;
